export enum EntityGroupTableColumns {
  Logo = "logo",
  EntityGroupId = "entityGroupId",
  ExternalId = "externalId",
  CodeLatin = "codeLatin",
  CodeLocal = "codeLocal",
  InternationalReference = "internationalReference",
  NameFullLatin = "nameFullLatin",
  NameFullLocal = "nameFullLocal",
  Status = "status",
}
